import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-article-line text-primary-500 mr-2"></i>
              深度好文
            </h2>
            <p className="text-foreground-500 text-sm">精选原创深度报道与独家分析</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cardItems.map((item, idx) => (
              <a
                key={idx}
                href="#cards"
                className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer no-underline transition-colors hover:bg-background-200"
              >
                <div className="aspect-[4/3] bg-background-200 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}